
import { Platform } from 'react-native';
import React from 'react';

let BottomSheet, BottomSheetScrollView, BottomSheetView;

if (Platform.OS === 'web') {
  BottomSheet = ({ children }) => <>{children}</>;
  BottomSheetScrollView = ({ children }) => <>{children}</>;
  BottomSheetView = ({ children }) => <>{children}</>;
} else {
  const gorhom = require('@gorhom/bottom-sheet');
  BottomSheet = gorhom.default;
  BottomSheetScrollView = gorhom.BottomSheetScrollView;
  BottomSheetView = gorhom.BottomSheetView;
}

export default {
  BottomSheet,
  BottomSheetScrollView,
  BottomSheetView,
};
